
































/* Created- 03 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ArticleSearch from "@/Views/Articles/ArticleSearch.vue";

import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ContentSearchHit, CustomerArticleLicenceDTO } from "../../Generated/ParticaAPI";
import ArticleActions from "@/Ui-Components/Article/Actions/ArticleActions.vue";
import ParticaDialogCard from "@/Ui-Components/Common/Container/ParticaDialogCard.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaAdminBase from "../Base/ParticaAdminBase.vue";
import { IParticaStoreService } from "../../BusinessServices/particastore";
import ViewArticleLicence from "@/Ui-Components/ArticleLicence/ViewArticleLicence.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import ParticaArticleProof from "@/Ui-Components/Article/Edit/ParticaArticleProof.vue";
import ParticaArticlePreview from "@/Ui-Components/Article/Preview/ParticaArticlePreview.vue";
import { IArticleService } from "../../BusinessServices/article";
import { IArticle, Article } from "../../Models/ArticleModels/article";

const namespace: string = "config";

@Component(
	{
		name: "AllArticles",
		components: {
			ParticaRowContainer,
			ParticaCard,
			ArticleSearch,
			ArticleActions,
			ParticaDialogCard,
			ParticaView,
			ParticaRightDrawer,
			ViewArticleLicence,
			ParticaArticleProof,
			ParticaArticlePreview
		}
	})
export default class AllArticles extends ParticaAdminBase {
	private query: string = "";
	private selectedArticle: ContentSearchHit = new ContentSearchHit();
	private showactions: boolean = false;
	private facets: string[] = [
		"publication",
		"issue",
		"article_type"
	];
	private showlicence: boolean = false;
	private licence: CustomerArticleLicenceDTO = new CustomerArticleLicenceDTO();
	private storeService: IParticaStoreService;
	private articlesvc: IArticleService;
	private showpreview: boolean = false;
	private article: IArticle = new Article();

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.VIEW_ARTICLE_LICENCE: {
					const selected: ContentSearchHit = event.item as ContentSearchHit;
					this.licence = await this.storeService.getCurrentArticleLicence(selected.articleId as string);
					this.showlicence = true;
					this.showactions = false;
					break;
				}
				case eParticaAction.ARTICLE_PREVIEW: {
					const selected: ContentSearchHit = event.item as ContentSearchHit;
					this.article = await this.articlesvc.getArticle(selected);
					this.showpreview = true;
					break;
				}
				case eParticaAction.ARTICLE_SELECT: {
					this.selectedArticle = event.item as ContentSearchHit;
					this.showactions = true;
					break;
				}
				case eParticaAction.CLOSE_DIALOG: {
					this.showactions = false;
					break;
				}
				case eParticaAction.ISSUE_SELECT: {
					this.selectedArticle = event.item as ContentSearchHit;
					if (this.selectedArticle !== undefined && this.selectedArticle.issueId !== undefined) {
						this.navigate("issue", { id: this.selectedArticle.issueId.toString() });
					}
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "All Partica Articles";
		this.storeService = this.particaServices.getParticaStoreService();
		this.articlesvc = this.particaServices.getArticleService();
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getAdminNav(0);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
